import React, { useState } from 'react';
import atob from 'atob';
import {
  signIn,
  confirmSignUp,
  resendSignUpCode,
} from '../../auth/authService';
import { useAuthDispatch, useAuthState } from '../../auth/authContext';
import { VERIFYING_USER } from '../../auth/authTypes';
import Monitor, { FingerPrint } from '../../lib/monitoring/Monitor';
import VerifyUser from './screen';
import Modal from '../../components/styled/Modal';
import View from '../../components/styled/View';
import { ALERT_TEXT, LIMIT_EXCEEDED } from './constants';

const VerifyUserContainer = ({ navigation, route }) => {
  const dispatch = useAuthDispatch();
  const { finishSetup } = route?.params || false;

  const { email, password } = useAuthState();
  const [finishUserSetup, setFinishUserSetup] = useState(finishSetup);
  const [verifyError, setVerifyError] = useState('');
  const [verifyLoading, setVerifyUserLoading] = useState(false);
  const [code, setCode] = useState('');

  // ==== MODAL ====
  const [modalVisible, setModalVisible] = useState(false);
  const [modalMessageText, setModalMessageText] = useState('');

  const setMonitorError = (message, userType = '', email = '') => {
    return {
      context: { user_email: email, user_type: userType },
      name: 'SignUp',
      fingerprint: FingerPrint.auth,
      message,
    };
  };
  const getErrorMessages = (error) => {
    const defaultErrorMessage = 'There has been an issue please try again';
    if (error && error.message) {
      return error.message;
    }
    return defaultErrorMessage;
  };

  const confirmEmailAddress = () => {
    setVerifyUserLoading(true);
    setVerifyError('');
    const sanitizedVerificationCode = code.trim();
    confirmSignUp(email, sanitizedVerificationCode)
      .then(() => {
        setVerifyUserLoading(false);
        const decryptedPassword = atob(password);
        signIn(email, decryptedPassword).then((response) => {
          const { attributes, signInUserSession, username } = response;
          const userType = attributes['custom:usertype'];
          const user = {
            userType,
            token: signInUserSession.accessToken.jwtToken,
            cognitoId: username,
            email,
          };
          dispatch({ type: VERIFYING_USER, ...user });
        });
      })
      .catch((err) => {
        setVerifyUserLoading(false);
        const errorMessage = getErrorMessages(err);
        setVerifyError(errorMessage);
        Monitor.notify(
          err,
          setMonitorError(
            'Error while user confirming email in sign up, confirmSignUp function',
            '',
            email,
          ),
        );
        console.error(err);
      });
  };

  const resendCode = () => {
    resendSignUpCode(email)
      .then(() => {
        setModalMessageText(ALERT_TEXT);
        setModalVisible(true);
      })
      .catch((err) => {
        console.error(err);
        Monitor.notify(
          err,
          setMonitorError(
            'Error while user requesting new code - request limit exceeded, resendCode function',
            '',
            email,
          ),
        );
        setModalMessageText(LIMIT_EXCEEDED);
        setModalVisible(true);
      });
  };
  const modalOverrideOnPress = () => {
    if (modalMessageText.includes('limit')) {
      return;
    }
    setFinishUserSetup(false);
  };

  return (
    <VerifyUser
      confirmEmailAddress={confirmEmailAddress}
      email={email}
      finishUserSetup={finishUserSetup}
      modalMessage={modalMessageText}
      modalOverrideOnPress={modalOverrideOnPress}
      modalVisible={modalVisible}
      navigation={navigation}
      setModalVisible={setModalVisible}
      setVerificationCode={setCode}
      resendCode={resendCode}
      verifyError={verifyError}
      verifyLoading={verifyLoading}
      verificationCode={code}
    />
  );
};

export default VerifyUserContainer;
